import * as PROJECT_CODE from '../../../constants/projectCode';
import firebase from '../../../lib/firebase.prod';

const firebaseRef = firebase.database();

export async function createStripeIdentification(lead, dbInfo) {
	try {
		let dbNode = dbInfo.node === 'lead' ? 'lead' : 'agreement';
		let email = lead?.email || lead?.clientEmail;
		let fName = lead?.clientFName || lead?.firstName;
		let leadId = dbInfo?.leadId;
		let individualId = dbInfo?.id || null;
		// BUG CLAY-2307: "ID Processing" takes to much time to appear on the modal after sending secure ID out
		// Solved: Update DB verification status===id processing, before sending Stripe API
		if (dbNode === 'lead') {
			firebaseRef
				.ref('/kavtek_leads/' + PROJECT_CODE.projectCode + `/${leadId}`)
				.update({
					identification: {
						verification: {
							status: 'requires_input',
						},
					},
				});
		} else {
			firebaseRef
				.ref(
					'/kavtek_agreements/' +
						PROJECT_CODE.projectCode +
						'/' +
						leadId +
						'/clientInfo/individual'
				)
				.once('value', (snapshot) => {
					let individualObjs = snapshot.val();
					let individualObjsKeys =
						individualObjs && Object.keys(individualObjs);
					let key =
						individualObjsKeys &&
						individualObjsKeys.filter(
							(key) => individualObjs[key].id === individualId
						);
					if (Array.isArray(key) && key.length === 1) {
						firebaseRef
							.ref(
								'/kavtek_agreements/' +
									PROJECT_CODE.projectCode +
									`/${leadId}` +
									'/clientInfo/individual/' +
									`${key}`
							)
							.update({
								identification: {
									verification: {
										status: 'requires_input',
									},
								},
							});
					}
				});
		}

		let params = {
			node: dbNode,
			email: email,
			fullName: fName,
			leadId: leadId,
			individualId: individualId,
			projectCode: PROJECT_CODE.projectCode,
		};

		let createStripeSession = firebase
			.functions()
			.httpsCallable('CreateStripeIdentitySession');
		dbNode && leadId && (await createStripeSession(params));
	} catch (err) {
		console.log(err.message);
	}
}

export async function getStripeDocumentUrl(file, callback) {
	try {
		let param = {
			file: file,
		};
		let getDocUrl = firebase
			.functions()
			.httpsCallable('GetStripeDocumentationImgUrl');
		let url = await getDocUrl(param);
		callback(url);
	} catch (err) {
		console.log(err.message);
	}
}

export async function cancelStripeIdentification(lead, dbInfo) {
	try {
		let sessionId = lead?.identification?.session?.id;
		let leadId = dbInfo?.leadId;
		let individualId = dbInfo?.id || null;
		let params = {
			sessionId: sessionId,
			node: dbInfo.node === 'lead' ? 'lead' : 'agreement',
			leadId: leadId,
			individualId: individualId,
			projectCode: PROJECT_CODE.projectCode,
		};
		let cancelStripeSession = firebase
			.functions()
			.httpsCallable('CancelStripeIdentification');

		if (sessionId && leadId) {
			await cancelStripeSession(params);
		}
	} catch (err) {
		console.log(err.message);
	}
}

export async function reSendStripEmail(lead, dbInfo, isFailed) {
	try {
		let sessionId = lead?.identification?.session?.id;
		let email = lead?.email || lead?.clientEmail;
		let fullName = lead?.firstName || lead?.clientFName;
		let dbNode = dbInfo.node === 'lead' ? 'lead' : 'agreement';
		let leadId = dbInfo?.leadId;
		let individualId = dbInfo?.id || null;

		let params = {
			sessionId: sessionId,
			fullName: fullName,
			email: email,
			node: dbNode,
			leadId: leadId,
			individualId: individualId,
			isFailed: isFailed,
			projectCode: PROJECT_CODE.projectCode,
		};

		if (sessionId && email && fullName && dbNode) {
			let sendEmail = firebase
				.functions()
				.httpsCallable('ReSendStripeVerificationEmail');
			await sendEmail(params);
		}
	} catch (err) {
		console.log(err.message);
	}
}
